import * as React from 'react';
import {Main} from "../components/Main";
import {Menu} from "../components/userPanelComponents/Menu";
import {Account} from "../components/userPanelComponents/Account";
import {Card} from "../components/userPanelComponents/Card";
import {Box} from "../components/sharedComponents/Box";
import TwojSklep from "../components/userPanelComponents/TwojSklep";

interface Props {
    active: number
}

const TYTULY: {[klucz: number]: string} = {1: 'Moje konto', 2: 'Karta', 3: 'Reklamacje', 5: 'Twój sklep stacjonarny'};

export const UserPanel = (props: Props) => {

    return <Main active={'USER'} title={TYTULY[props.active]}>
        <Box>
            <div className={'userPanel'}>
                <div className={'row'}>
                    <div className={'col-sm-2'}>
                        <Menu active={props.active}/>
                    </div>
                    <div className={'col-sm-10'}>
                        {props.active === 1 && <Account/>}
                        {props.active === 2 && <Card/>}
                        {props.active === 3 && <h1 className={'h3'}>Reklamacje</h1>}
                        {props.active === 5 && <TwojSklep/>}
                    </div>
                </div>
            </div>
        </Box>
    </Main>

}

UserPanel.defaultProps = {}

